var React = require('react');

function HatWizard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 464v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h480a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M240 416h208l-86.41-201.63a64 64 0 0 1-1.89-45.45L416 0 228.42 107.19A128 128 0 0 0 175 166.34L64 416h144l-16-32-64-32 64-32 32-64 32 64 64 32-64 32zm48-224l-16 32-16-32-32-16 32-16 16-32 16 32 32 16z","className":"fa-primary","key":2})]);
}

HatWizard.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = HatWizard;

HatWizard.default = HatWizard;
